/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M15 16h-2V8h2m-4 8H9V8h2m1-6A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2z"/>'
  }
})
